window.slugify = require('slugify')
